import Modal from '@space-core/components/modal'
import styled from 'styled-components'

export const CustomModal = styled(Modal)`
  --modal-max-width: 50rem;
  --modal-backdrop-pointer-events: none;
`

CustomModal.displayName = 'CustomModal'

export const ErrorStateLabel = styled.p`
  color: var(--red-darker);
`

CustomModal.displayName = 'ErrorStateLabel'

export const Divider = styled.div`
  border-bottom: 0.063rem solid var(--gray-200);
`

Divider.displayName = 'Divider'
